const { NODE_ENV, VUE_APP_GATEWAY_HTTP: GATEWAY_HTTP } = process.env;

export { GATEWAY_HTTP, NODE_ENV };
